import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import axios from 'axios';

// Axios Interceptor to dynamically redirect localhost requests to the deployed API base URL in production
axios.interceptors.request.use(
  (config) => {
    const isProduction = typeof window !== 'undefined' && 
      window.location.hostname !== 'localhost' && 
      window.location.hostname !== '127.0.0.1';

    const apiBase = (process.env.REACT_APP_API_URL && !process.env.REACT_APP_API_URL.includes('localhost')) 
      ? process.env.REACT_APP_API_URL 
      : (typeof window !== 'undefined' ? window.REACT_APP_API_URL : null);

    if (config.url && config.url.startsWith('http://localhost:5000')) {
      if (apiBase) {
        config.url = config.url.replace('http://localhost:5000', apiBase);
      }
    }

    // Automatically convert HTTP API endpoints to HTTPS in production HTTPS environment to prevent mixed-content blocks
    if (typeof window !== 'undefined' && window.location.protocol === 'https:' && config.url && config.url.startsWith('http://') && !config.url.includes('localhost') && !config.url.includes('127.0.0.1')) {
      config.url = config.url.replace('http://', 'https://');
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);